module.exports = __webpack_public_path__ + "img/img32.ad160c3e.png";